<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  class="bv-account-dialog bv-domain-rules-dialog"
  [title]="'addCustomDomain' | i18n"
>
  <ng-container bitDialogContent>
    <div class="bv-domain-rules-dialog__fields" formArrayName="domains">
      @for (control of domainControls; track i; let i = $index) {
        <div class="bv-domain-rules-dialog__field-row">
          <bit-form-field class="bv-mat-field tw-w-full">
            <bit-label>{{ "customDomainX" | i18n: i + 1 }}</bit-label>
            <input
              bitInput
              [formControlName]="i"
              placeholder="{{ 'ex' | i18n }} google.com, gmail.com"
            />
          </bit-form-field>
          <button
            type="button"
            bitIconButton="bwi-minus-circle"
            buttonType="dangerGhost"
            class="bv-domain-rules-dialog__remove-btn"
            [label]="'remove' | i18n"
            (click)="removeDomainRow(i)"
          ></button>
        </div>
      }
    </div>

    <button type="button" class="bv-domain-rules-dialog__add-link" (click)="addDomainRow()">
      <span class="bv-domain-rules-dialog__add-link-icon" aria-hidden="true"></span>
      {{ "addDomain" | i18n }}
    </button>
  </ng-container>

  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer">
      <div class="bv-account-dialog__footer-end">
        <button
          bitButton
          bitFormButton
          type="button"
          buttonType="secondary"
          class="bv-account-dialog__cancel-btn"
          bitDialogClose
        >
          {{ "cancel" | i18n }}
        </button>
        <button
          bitButton
          bitFormButton
          type="submit"
          buttonType="primary"
          class="bv-account-dialog__save-btn"
        >
          {{ "save" | i18n }}
        </button>
      </div>
    </div>
  </ng-container>
</form>
